import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBooleanGroupUnion2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBooleanGroupUnion2"><Path fillRule="evenodd" clipRule="evenodd" d="M8 2V8H2V22H16V16H22V2H8ZM13 16H8V11H10V14H13V16ZM11 8V10H14V13H16V8H11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBooleanGroupUnion2;
